"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StoreContext_1 = require("./StoreContext");
Object.defineProperty(exports, "StoreContextProvider", { enumerable: true, get: function () { return StoreContext_1.default; } });
Object.defineProperty(exports, "StoreContext", { enumerable: true, get: function () { return StoreContext_1.StoreContext; } });
//# sourceMappingURL=index.js.map